import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { route } from 'preact-router';
import linkstate from 'linkstate';

import ImageScroller from '../../components/imagescroller';
import Placeholder from '../../components/gui/placeholder';
import MarkdownDisplay from '../../components/gui/markdownDisplay';
import VideoStreamingPlayer from '../../routes/videostreaming/player';
import Likes from '../../components/likes';

import localUtil from '../../lib/util';
import EmojiPicker from '../gui/emojiPicker';

@observer
class Comments extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            body: '',
            comments: null,
        };
        this.inputRef = null;
    }

    loadAll = async (props = this.props) => {
        const { comments = [] } = this.props;
        const { userStore } = this.props.stores;
        const { user } = userStore;
        const userHascommented = comments.find(comment => comment.user === user.id);
        if (userHascommented) {
            this.setState({ hascommented: true });
        }
    }

    onInput = e => {
        e.stopPropagation();
        e.preventDefault();
        this.setState({ body: e.target.value });
    }

    onKeyDown = e => {
        e.stopPropagation();
        // e.preventDefault();
    }

    onFocus = e => {
        this.setState({
            showAddCommentEdit: true,
        })
    }

    onBlur = e => {
        // this.setState({
        //     showAddCommentEdit: false,
        // });
    }

    addComment = async () => {
        const { body, replyToCommentId } = this.state;
        if (!body || body.length < 1) {
            return;
        }
        const { commentStore } = this.props.stores;
        const { type, objectId } = this.props;

        if (replyToCommentId) {
            // If replying to a comment, prepend the reply text to the body
            await commentStore.insert({
                type: 'comment',
                objectId: replyToCommentId,
                body,
            });
            this.setState({ hascommented: true, body: '', showAddCommentEdit: false, replyToCommentId: null });
            const comments = await commentStore.load({
                query: { type, objectId },
                skipUpdate: true,
            });
            this.setState({ comments });
        } else {
            await commentStore.insert({ type, objectId, body });
            this.setState({ hascommented: true, body: '', showAddCommentEdit: false });

            const comments = await commentStore.load({
                query: { type, objectId },
                skipUpdate: true,
            });
            this.setState({ comments });
        }

        this.toggleComment();
    }

    removeComment = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        const { commentid, objectid } = e.target.closest('button').dataset;
        console.log('removeComment', commentid, e.target, e.target.closest('button'));
        if (!commentid) {
            return;
        }
        if (!window.confirm('Are you sure you want to delete this comment?')) {
            return;
        }
        const { type, objectId } = this.props;
        const { commentStore } = this.props.stores;
        await commentStore.delete(commentid, 'id', { objectId: objectid });

        const comments = await commentStore.load({
            query: { type, objectId },
            skipUpdate: true,
        });
        this.setState({ comments });
    }

    editComment = async () => {
        const { body } = this.state;
        const { type, objectId } = this.props;
        const { commentStore } = this.props.stores;
        const updateObject = {
            id: 1,
            type,
            objectId,
            body: this.state.body,
        };
        await commentStore.update(updateObject);

        const comments = await commentStore.load({
            query: { type, objectId },
            skipUpdate: true,
        });
        this.setState({ comments });
    }

    toggleComment = async () => {
        const { commentStore } = this.props.stores;
        const { showAddComment = {} } = commentStore;
        const { type, objectId } = this.props;

        const addComment = { ...showAddComment };
        addComment[`${type}-${objectId}`] = !addComment[`${type}-${objectId}`];
        commentStore.updateKeyValue('showAddComment', addComment);
    }

    toggleEmojiPicker = (e) => {
        e.stopPropagation();
        e.preventDefault();
        const { showEmojiPicker } = this.state;
        // Toggle the visibility of the emoji picker
        this.setState({
            showEmojiPicker: !showEmojiPicker,
        });
    }

    addEmoji = (emoji) => {
        // Get field by inputRef
        const input = this.inputRef;
        if (input) {
            // Insert emoji at the cursor position
            const start = input.selectionStart;
            const end = input.selectionEnd;
            const value = input.value || '';
            const newValue = value.slice(0, start) + emoji + value.slice(end);
            input.value = newValue;
            // Trigger input event to update the field
            input.dispatchEvent(new Event('input', { bubbles: true }));
        }
    }

    toggleCommentReply = (e) => {
        e.stopPropagation();
        e.preventDefault();
        const { commentid } = e.target.dataset;
        if (!commentid) {
            return;
        }
        const { appState } = this.props.stores;
        const { appContainer } = appState;

        // console.log('toggleCommentReply', commentid, e.target, e.target.closest('small'));
        this.setState({
            replyToCommentId: parseInt(commentid, 10) || null,
        }, () => {
            if (this.inputRef) {
                // Scroll inputref into view
                // const appContainer = document.querySelector('.appContainer');
                // if (!appContainer) {
                //     return;
                // }
                appContainer.scrollTop = this.inputRef.offsetTop; // Adjust the offset as needed
                this.inputRef.focus();
                console.log('inputRef', this.inputRef, this.inputRef.getBoundingClientRect());

                // Scroll to the input field
                // const rect = this.inputRef.getBoundingClientRect();
                // appContainer.scrollTo({
                //     top: rect.top + 300, // Adjust the offset as needed
                //     left: rect.left,
                //     behavior: 'smooth',
                // });
            }
        });
    }

    componentDidMount() {
        this.loadAll();
    }

    renderComment = ({ comment, isOwnComment, isSubComment, parentComment, className }) => {
        const { localLikes = [] } = this.state;
        const {
            objectId,
        } = this.props;
        return (<>
            <div class='d-flex flex-row w-100 justify-content-between'>
                <div
                    class={`commentBubble ${isOwnComment ? 'myComment' : 'othersComment'} position-relative pt-1 ${className || ''}`}
                    key={comment.id}  // recommended if you have a unique id
                >
                    <div class='commentBody'>
                        <small class='font-weight-bold'>{comment.creator}</small><br />
                        <MarkdownDisplay markdown={comment.body || '&nbsp;'} />
                        {comment.likes && comment.likes.length > 0 ? <>
                            <div
                                class='likesCount position-absolute text-muted rounded-pill px-1 py-0 border'
                                style={`
                                    bottom: -5px; right: -5px;
                                    background-color: rgba(255, 255, 255, 0.8);
                                    font-size: 0.6rem;
                                    line-height: 0.8rem;
                                `}
                            >
                                {comment.likes.length} <i class='fa-regular fa-thumbs-up' />
                            </div>
                        </> : <></>}
                    </div>
                </div>
            </div>
            <div class={`d-flex flex-row w-100 justify-content-${isOwnComment ? 'start' : 'start'} mt-0 mb-2`}>
                <small class=''>{localUtil.getTimeAgo(comment.createdDate)}</small>
                <small class='text-muted px-2'>
                    •
                </small>
                <Likes
                    stores={this.props.stores}
                    type={'comment'}
                    objectId={comment.id}
                    uuidv4={comment.uuidv4}
                    likes={comment.likes}
                    inputLikes={localLikes}
                    showSimpleLike={true}
                />
                <small class='text-muted px-2'>
                    •
                </small>

                {isSubComment && parentComment?.id ? <>
                    <small
                        class='text-muted'
                        onClick={this.toggleCommentReply}
                        data-commentid={parentComment.id}
                    >
                        <Text id='comment.reply'>Reply</Text>
                    </small>
                </> : <>
                    <small
                        class='text-muted'
                        onClick={this.toggleCommentReply}
                        data-commentid={comment.id}
                    >
                        <Text id='comment.reply'>Reply</Text>
                    </small>
                </>}

                {isOwnComment ? <>
                    <small class='text-muted px-2'>
                        •
                    </small>
                    <button
                        class='btn btn-link btn-sm text-muted p-0'
                        style='font-size: 0.8rem;'
                        onClick={this.removeComment}
                        data-commentid={comment.id}
                        data-objectid={isSubComment ? parentComment.id : objectId }  // Use objectId if available, otherwise use id
                    >
                        <i class='fa-duotone fa-trash'></i>
                    </button>
                    {/* {comment.user === user.id ? <>
                        <button
                            class='btn btn-link btn-sm text-muted p-0'
                            onClick={this.editComment}
                        >
                            <i class='fa-duotone fa-pen'></i>
                        </button>
                    </> : <></>} */}
                </> : <></>}
            </div>
        </>);
    }

    render() {
        const {
            showEmojiPicker = false,
            showAddCommentEdit,
            comments: localComments,
            body,
            localLikes = [],
            replyToCommentId,
        } = this.state;
        const {
            comments = [],
            type,
            objectId,
        } = this.props;
        const { appState, userStore, commentStore } = this.props.stores;
        const { user } = userStore;
        const isLoggedIn = user.id;

        const { showAddComment } = commentStore;

        const finalComments = localComments || comments;

        const replyToComment = finalComments.find(comment => comment.id === replyToCommentId);

        return (<>
            <div class='w-100 d-flex flex-column justify-content-between position-relative text-muted px-3 py-2'>

                {/* <xmp>{JSON.stringify(finalComments, null, 2)}</xmp> */}

                {finalComments.map(comment => {
                    const isOwnComment = comment.user === user.id;

                    return (<>
                        {this.renderComment({ comment, isOwnComment })}
                        {comment.comments && comment.comments.length > 0 ? <>
                            <div class='ml-4'>
                                {comment.comments.map(subComment => {
                                    const isOwnSubComment = subComment.user === user.id;
                                    return this.renderComment({ comment: subComment, isOwnComment: isOwnSubComment, isSubComment: true, parentComment: comment, className: 'comment-replies'});
                                })}
                            </div>
                        </> : <></>}
                    </>);
                })}

                {/* TODO: Consider when to show this */}
                {true || showAddComment[`${type}-${objectId}`] || (isLoggedIn && finalComments.length === 0) ? <>
                    {replyToComment && <div class='d-flex flex-column w-100 justify-content-start mb-2 border-top pt-2'>
                        <small class='font-weight-light'><Text id='comment.replyingTo'>Replying to {replyToComment.user.name}</Text>:</small>
                        <div class={`commentBubble ${replyToComment.user.id === user.id ? 'myComment' : 'othersComment'} position-relative pt-1`}>
                            <div class='commentBody'>
                                <small class='font-weight-bold'>{replyToComment.creator}</small><br />
                                <MarkdownDisplay markdown={replyToComment.body || '&nbsp;'} />
                            </div>
                        </div>
                    </div>}

                    <div class='d-flex flex-row'>
                        <Localizer>
                            <textarea
                                ref={c => this.inputRef = c}
                                class='form-control'
                                placeholder={<Text id='comment.addComment'>Add a comment...</Text>}
                                onInput={this.onInput}
                                rows={1}
                                onKeyDown={this.onKeyDown}
                                onKeyUp={localUtil.resizeTextarea}
                                onFocus={this.onFocus}
                                onBlur={this.onBlur}
                                value={body}
                            ></textarea>
                        </Localizer>
                        <button
                            class='btn btn-primary'
                            onClick={this.addComment}
                        >
                            <i class="fa-duotone fa-paper-plane"></i>
                        </button>
                    </div>
                    {showAddCommentEdit ? <>
                        {/* Add useful comment editing features here. I am not sure what is should be yet, but maybe facebook and instagram has any nice features we could implement. Like adding emojis, etc. */}
                        <div class='d-flex flex-row'>
                            <button class='btn btn-link text-muted p-0' onClick={this.toggleEmojiPicker}>
                                <i class={`${showEmojiPicker ? 'fa-solid' : 'fa-regular'} fa-face-smile`} />
                            </button>
                        </div>
                        {showEmojiPicker && <>
                            <EmojiPicker stores={this.props.stores} addEmoji={this.addEmoji} />
                        </>}
                    </> : <></>}
                </> : <></>}

            </div>
        </>);
    }
}

export default Comments;
